 precision mediump float;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform float uProportion1;
uniform float uProportion2;
uniform float uTime;
uniform float uMovementAmplitude;
uniform vec2 uResolution;
uniform float uNoiseScale;
uniform float uMovementSpeed;
varying vec2 vUv;

// Simplex 2D noise
vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float staticNoise(vec2 st) {
    return fract(sin(dot(st.xy, vec2(12.9898, 78.233))) * 43758.5453123);
}

void main() {
    vec2 st = vUv.yy;

    st.y += sin(uTime * uMovementSpeed) * uMovementAmplitude;

    vec3 color1 = uColor1;
    vec3 color2 = uColor2;
    vec3 color3 = uColor3;
    
    vec3 color;
    if (st.y < uProportion1) {
        color = mix(color1, color2, st.y / uProportion1);
    } else if (st.y < uProportion1 + uProportion2) {
        color = mix(color2, color3, (st.y - uProportion1) / uProportion2);
    } else {
        color = color3;
    }
    
    // Static noise effect with controllable scale
    float noiseScale = 1.;
    float noiseIntensity = .08;

    vec2 noiseCoord = floor(gl_FragCoord.xy * noiseScale) / (uResolution);
    float noise = (staticNoise(noiseCoord) - .5) * noiseIntensity;
    color += noise;
    
    gl_FragColor = vec4(color, 1.0);
}